<div
  class="error-report-panel"
  [class.error-report-panel--loading]="localLoading"
>
  <div class="error-report-local-loader" *ngIf="localLoading">
    <span class="error-report-local-loader__spinner"></span>
  </div>

  <p-tabView
    [activeIndex]="activeTab"
    (activeIndexChange)="onTabChange($event)"
  >
    <p-tabPanel header="Erros">
      <div class="error-summary-panel" *ngIf="errorSummaryRows.length > 0">
        <div class="error-summary-panel__header">
          <span>Mensagem de erro</span>
          <span>Total</span>
        </div>
        <div class="error-summary-panel__body">
          <div class="error-summary-row" *ngFor="let row of errorSummaryRows">
            <span class="error-summary-row__message" [title]="row.message">{{
              row.message
            }}</span>
            <span class="error-summary-row__total">{{
              row.total | number
            }}</span>
          </div>
        </div>
      </div>

      <div class="config-warning" *ngIf="errorSummaryRows.length === 0">
        Nenhum totalizador de erro encontrado para esta rodada.
      </div>

      <app-table
        *ngIf="paymentRoundId"
        [lazy]="true"
        [findPage]="findErrorsPage"
        [cols]="errorCols"
        [fixedFilters]="fixedFilters"
        [addButton]="false"
        [showTitle]="false"
        [defaultRows]="10"
        [service]="paymentRoundService"
        modelName="erros da rodada"
      />
    </p-tabPanel>

    <p-tabPanel header="Pagamentos">
      <div class="config-warning" *ngIf="paymentsLoading">
        Carregando pagamentos...
      </div>

      <app-table
        *ngIf="paymentsLoaded && payments.length > 0"
        [lazy]="false"
        [elements]="payments"
        [cols]="paymentCols"
        [addButton]="false"
        [showTitle]="false"
        modelName="pagamentos da rodada"
      />

      <div
        class="config-warning"
        *ngIf="paymentsLoaded && payments.length === 0"
      >
        Nenhum pagamento encontrado para esta rodada.
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
